import { render, staticRenderFns } from "./WineryTable.vue?vue&type=template&id=073fe0ee&scoped=true&"
import script from "./WineryTable.vue?vue&type=script&lang=ts&"
export * from "./WineryTable.vue?vue&type=script&lang=ts&"
import style0 from "./WineryTable.vue?vue&type=style&index=0&id=073fe0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073fe0ee",
  null
  
)

export default component.exports